export default function StatCard({ icon, label, value, tone = "green", sub }) {
  return (
    <article className={`admin-stat-card ${tone}`}>
      <span className="admin-stat-icon"><i className={`fa-solid ${icon}`} /></span>
      <div>
        <span>{label}</span>
        <strong>{value}</strong>
        {sub && <small>{sub}</small>}
      </div>
    </article>
  );
}
